import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { ReceiversService } from 'src/app/shared/services/receivers.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(private auth: AuthService, private receiversService: ReceiversService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // if (environment.production) {
    //   if (!this.auth.isLoggedInCloud() && !this.auth.isLoggedIn()) {
    //     this.auth.logout();
    //     return false;
    //   }

    //   if (this.auth.isLoggedInCloud() && !this.auth.isLoggedIn()) {
    //     this.auth.cloudLogin().subscribe({
    //       next: (data) => {
    //         if (data.success && data.token) {
    //           this.router.navigateByUrl('maps');
    //           this.receiversService.connectReceivers();
    //         } else {
    //           this.auth.logout();
    //         }
    //       },
    //       error: () => {
    //         this.auth.logout();
    //       },
    //     });
    //     return false;
    //   }
    // } else {
    if (!this.auth.isLoggedIn() && state.url !== '/login') {
      this.router.navigateByUrl('/login');
      return false;
    } else if (this.auth.isLoggedIn() && state.url === '/login') {
      this.router.navigateByUrl('/maps');
      return false;
    } else if (this.auth.isLoggedIn() && state.url === '/techsupport' && !this.auth.user.enableTechSupport) {
      this.router.navigateByUrl('/maps');
      return true;
    }
    // }

    return true;
  }
}
